export const SYSTEM_SETTING_LIST = "SYSTEM_SETTING_LIST";
export const SYSTEM_SETTING_STORE = "SYSTEM_SETTING_STORE";
export const SYSTEM_SETTING_EDIT = "SYSTEM_SETTING_EDIT";
export const SYSTEM_SETTING_UPDATE = "SYSTEM_SETTING_UPDATE";
export const SYSTEM_SETTING_DELETE = "SYSTEM_SETTING_DELETE";
export const SYSTEM_SETTING_UPDATE_STATUS = "SYSTEM_SETTING_UPDATE_STATUS";